"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemNotInitializedError = void 0;
class ItemNotInitializedError extends Error {
    constructor() {
        super('Item has not been initialized');
    }
}
exports.ItemNotInitializedError = ItemNotInitializedError;
//# sourceMappingURL=ItemFactory.errors.js.map